/**
 * "Set due date" is reachable from the palette (`>` mode), which is mounted in the shell and
 * knows only the current page's id. The control itself lives in the page header. Same problem
 * as the event dialog, same answer: a tiny external store and a host mounted once.
 */
type Listener = () => void;

const listeners = new Set<Listener>();
let pageId: string | null = null;

export function subscribeDueDate(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getDueDatePage(): string | null {
  return pageId;
}

export function openDueDate(id: string): void {
  pageId = id;
  for (const listener of listeners) listener();
}

export function closeDueDate(): void {
  pageId = null;
  for (const listener of listeners) listener();
}
